import React, {useState} from 'react'
import {useDispatch} from "react-redux"
import {SET_PER_PAGE} from "redux/types"
import {setVariable} from "redux/actions"
import {Button, Menu, MenuItem, Tooltip} from "@material-ui/core"

const RecordsPerPage = ({meta}) => {
    const dispatch = useDispatch()
    const [pageMenuOpen, setPageMenuOpen] = useState(null);

    const handleMenuItem = (value) => () => {
        dispatch(setVariable(SET_PER_PAGE, value));
        handleMenu()
        return false;
    };

    const MenuItems = [
        {handleClick: handleMenuItem(20), page: 20},
        {handleClick: handleMenuItem(30), page: 30},
        {handleClick: handleMenuItem(50), page: 50},
    ];
    const handleMenu = event => setPageMenuOpen(pageMenuOpen ? null : event.currentTarget);

    const toNumber = meta?.to || 0;
    const fromNumber = meta?.from || 0;
    const totalNumber = meta?.total || 0;

    return (
        <div>
            <Tooltip title="RECORDS PER PAGE">
                <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleMenu}>
                    {`${fromNumber} - ${toNumber} of ${totalNumber}`}
                </Button>
            </Tooltip>
            <Menu id="simple-menu" anchorEl={pageMenuOpen} keepMounted open={Boolean(pageMenuOpen)}
                  onClose={() => handleMenu()}>
                {MenuItems.map((menuItem, index) =>
                    <MenuItem key={index} onClick={menuItem.handleClick}> {menuItem.page} per page </MenuItem>
                )}
            </Menu>
        </div>
    );
};

export default RecordsPerPage;